import { Box, Typography } from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import BradyChatbotIcon from './BradyChatbotIcon';
import MuiMarkdown from 'mui-markdown';

interface ChatBubbleProps {
  message: string | JSX.Element;
  isUser: boolean;
  backgroundColor?: string;
}

const ChatBubble: React.FC<ChatBubbleProps> = ({
  message,
  isUser,
  backgroundColor,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-start',
        width: '100%',
        alignItems: 'flex-start',
        marginBottom: isUser ? '25px' : '5px',
      }}
    >
      {isUser && <AccountCircleIcon fontSize="large" />}
      {!isUser && <BradyChatbotIcon fontSize="large" />}
      <Box
        sx={{
          backgroundColor: backgroundColor,
          color: 'black',
          borderRadius: '20px',
          padding: '10px 15px',
        }}
      >
        {typeof message === 'string' ? (
          <MuiMarkdown
            overrides={{
              ul: {
                component: 'ul',
                props: {
                  style: {
                    paddingLeft: '20px',
                  },
                },
              },
            }}
          >
            {message}
          </MuiMarkdown>
        ) : (
          <Typography>{message}</Typography>
        )}
      </Box>
    </Box>
  );
};

export default ChatBubble;
